import { CSSObjectWithLabel } from 'react-select';
import {
  Control,
  Option,
  DropdownIndicator,
  IndicatorsContainer,
  Menu,
  MenuList,
  SelectContainer,
  ValueContainer,
  ClearIndicator,
} from './components';

export const customStyles: any = {
  input: (provided: CSSObjectWithLabel) => ({
    ...provided,
    margin: 0,
    padding: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    boxShadow: 'none',
  }),
  control: () => ({}),
  menu: () => ({}),
  option: () => ({}),
};

const nullComponents = {
  MultiValue: () => null,
  GroupHeading: () => null,
  IndicatorSeparator: () => null,
};

const replaceableComponents = {
  IndicatorsContainer,
  MenuList,
  Option,
  Control,
  SelectContainer,
  ValueContainer,
  DropdownIndicator,
  Menu,
  ClearIndicator,
};

export const components = {
  ...nullComponents,
  ...replaceableComponents,
};
